import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState, Subtask } from '../types';
import { getCardById } from '../use';
import { useStorymapStore } from '../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

type UpdateCardFromRealtimeType = 'activity' | 'task' | 'subtask';

export class UpdateCardFromRealtime extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'UpdateCardFromRealtime';

    public constructor(
        public type: UpdateCardFromRealtimeType,
        public id: string,
        public title: string,
        public description: string,
        public color: number,
        public order: number,
        public key?: string,
        public activityId?: string,
        public taskId?: string,
        public releaseId?: string,
        public assigneeUserId?: string,
        public estimation?: number,
        public statusKey?: number,
        public statusName?: string,
        public basicPrioValue?: number,
        public moscowPrioValue?: number,
        public kanoPrioValue?: number,
        public businessValueInt?: number,
        public effortInt?: number,
        public releaseViewOrder?: number,
        public annotationIds?: string[],
        public personaIds?: string[],
        public createdAt?: Date,
        public createdByUserId?: string,
        public lastUpdatedAt?: Date,
        public lastUpdatedByUserId?: string
    ) {
        super(UpdateCardFromRealtime.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => {
    return true;
};

const reducer = (state: StorymapState, action: UpdateCardFromRealtime): void => {
    const existingCard = getCardById(action.id);
    if (!existingCard) {
        return;
    }

    // Update common card properties
    existingCard.title = action.title;
    existingCard.description = action.description || '';
    existingCard.color = action.color;
    existingCard.hasDescription = action.description != null && action.description.trim() !== '';
    existingCard.assigneeUserId = action.assigneeUserId || null;
    existingCard.key = action.key || existingCard.key;
    existingCard.lastUpdatedAt = action.lastUpdatedAt || null;
    existingCard.lastUpdatedByUserId = action.lastUpdatedByUserId || null;

    // Update annotation and persona IDs on any card type
    if (action.annotationIds != null) {
        existingCard.annotationIds = action.annotationIds;
    }
    if (action.personaIds != null) {
        existingCard.personaIds = action.personaIds;
    }

    // Update subtask-specific properties
    if (action.type === 'subtask') {
        const subtask = state.subtasks.find((x) => x.id === action.id);
        if (subtask) {
            subtask.estimation = action.estimation;
            subtask.status = action.statusKey ?? subtask.status;
            // Each framework slot is assigned on its own, mirroring the initial load. Writing the
            // active framework's value into all three slots would leave a stale value behind after
            // the story map switches its priority framework.
            if (action.basicPrioValue !== undefined) {
                subtask.basicPrioValue = action.basicPrioValue;
            }
            if (action.moscowPrioValue !== undefined) {
                subtask.moscowPrioValue = action.moscowPrioValue;
            }
            if (action.kanoPrioValue !== undefined) {
                subtask.kanoPrioValue = action.kanoPrioValue;
            }
            if (action.businessValueInt !== undefined) {
                subtask.businessValue = action.businessValueInt;
            }
            if (action.effortInt !== undefined) {
                subtask.effort = action.effortInt;
            }
            subtask.releaseViewOrder = action.releaseViewOrder ?? null;
        }
    }
};

//@ts-ignore
registerMiddleware(UpdateCardFromRealtime.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(UpdateCardFromRealtime.ACTION_TYPE, reducer);
